import { render, staticRenderFns } from "./CompanyListConfig.vue?vue&type=template&id=74be21b8&"
import script from "./CompanyListConfig.vue?vue&type=script&lang=js&"
export * from "./CompanyListConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports